export const OPTISECUR_COMPANY_ID = '00000000-0000-0000-0000-000000000001';

export const MIN_DIAGNOSTICS_FOR_COMPARISON = 50;

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  COMPANY_ADMIN: 'company_admin',
  ADVISOR: 'advisor',
  CLIENT: 'client',
} as const;

export type UserRole = typeof ROLES[keyof typeof ROLES];
